import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getMauDanhGia(payload: { page: number; limit: number; cond?: any }) {
  return axios.get(`${ip3}/danh-gia-hoc-sinh/mau-danh-gia-chung/pageable`, {
    params: {
      ...payload,
      cond: {
        ...payload.cond,
      },
    },
  });
}

export async function getHoatDongDanhGia(payload: { page: number; limit: number; cond?: any }) {
    return axios.get(`${ip3}/danh-gia-hoc-sinh/hoat-dong-chung/pageable`, {
      params: {
        ...payload,
        cond: {
          ...payload.cond,
        },
      },
    });
}

export async function addHoatDongChung(payload: any) {
  console.log("payload: ", payload);
  return axios.post(`${ip3}/danh-gia-hoc-sinh/hoat-dong-chung`, payload);
}

export async function editHoatDongChung(payload: any) {
  const { id } = payload;
  return axios.post(`${ip3}/danh-gia-hoc-sinh/hoat-dong-chung/${id}`, payload);
}

export async function addMauDanhGia(payload: any) {
  return axios.post(`${ip3}/danh-gia-hoc-sinh/mau-danh-gia-chung`, payload);
}

export async function editMauDanhGia(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/danh-gia-hoc-sinh/mau-danh-gia-chung/${id}`, payload);
}

export async function delHoatDongChung(payload: any) {
  const { id } = payload;
  return axios.delete(`${ip3}/danh-gia-hoc-sinh/hoat-dong-chung/${id}`);
}

export async function delMauDanhGiaChung(payload: any) {
  const { id } = payload;
  return axios.delete(`${ip3}/danh-gia-hoc-sinh/mau-danh-gia-chung/${id}`);
}
